$(document).ready(function () {
    $('form[action]').on('submit', function (e) {

        const $submitButton = $(e.target).find('button[type="submit"]');

        if (!$submitButton) return;

        $submitButton.prop('disabled', true);

        setTimeout(() => {
            $submitButton.prop('disabled', false);
        }, 4000);
    });
});